import React from 'react';
import StepWizard from 'react-step-wizard';
import { ForgotPasswordProvider } from './ForgotPasswordContext';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';

function ForgotPasswordWrapper() {
  return (
    <ForgotPasswordProvider>
      <ForgotPassword />
    </ForgotPasswordProvider>
  );
}

function ForgotPassword() {
  return (
    <div className='w-full overflow-hidden rounded-[20px] bg-white shadow-[0_4px_32px_rgba(11,25,41,0.08)]'>
      <StepWizard>
        <Step1 />
        <Step2 />
        <Step3 />
      </StepWizard>
    </div>
  );
}

export default ForgotPasswordWrapper;
